import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation(); // React Router hook to get the current location

  useEffect(() => {
    // Scroll to the top of the page whenever the route changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]); // Run the effect when the location changes

  return null; // This component does not need to render anything
};

export default ScrollToTop;
